import { Icon } from '../Icon'
import styles from './TabSection.module.css'

type Accent = 'blue' | 'teal' | 'amber' | 'purple' | 'red'

interface TabSectionProps {
  icon: string
  title: string
  subtitle: string
  accent: Accent
  children: React.ReactNode
}

export function TabSection({ icon, title, subtitle, accent, children }: TabSectionProps) {
  return (
    <div className={`${styles.section} ${styles[accent]}`}>
      <div className={styles.sidebar}>
        <div className={`${styles.iconBox} ${styles[`icon_${accent}`]}`}>
          <Icon name={icon} size="md" />
        </div>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  )
}
